export enum MissingDataTrigger {
  ACTIVE_SOURCING = 'active-sourcing',
  MANUAL_APPLICATION = 'manual-application',
  JOB_CHANGED = 'job-changed',
  JOB_MOVED = 'job-moved',
}
